import { render, staticRenderFns } from "./ManageTechnologies.vue?vue&type=template&id=a9ddb4e8&scoped=true&"
import script from "./ManageTechnologies.vue?vue&type=script&lang=ts&"
export * from "./ManageTechnologies.vue?vue&type=script&lang=ts&"
import style0 from "./ManageTechnologies.vue?vue&type=style&index=0&id=a9ddb4e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ddb4e8",
  null
  
)

export default component.exports